import { createSelector } from 'reselect';
import { values } from 'ramda';
import { getSearchFieldsTemplate } from '../../components/search/search.constants';
import { SearchSelector } from './search.selectors';
import { getCustomerIdentifier } from '../../reducers/helpers/customer.helper';
import { SubscriberStatesMapSelector } from '../../reducers/selectors/customer.selectors';
import { BusinessUnitFetchFeatureToggleValuesSelector } from 'invision-core/src/components/configurable/configurable.selectors';
var CustomerSearchSelector = createSelector([SearchSelector], function (search) {
  return search.customers;
});
export var CustomerSearchMapSelector = createSelector([CustomerSearchSelector, SubscriberStatesMapSelector], function (customers, stateMap) {
  var map = {};
  values(customers.data).forEach(function (item) {
    map[item.Id] = item.asMutable({
      deep: true
    });

    //Get the current stateName, either Global or BU specific
    var itemState = map[item.Id].State;
    map[item.Id].displayName = getCustomerIdentifier(item);
    map[item.Id].stateName = itemState >= 0 ? stateMap[itemState] : '';
  });
  return map;
});
export var CustomerSearchArraySelector = createSelector([CustomerSearchMapSelector], function (customerSearchMap) {
  return customerSearchMap ? (values(customerSearchMap) || []).sort(function (a, b) {
    return a.sortIndex - b.sortIndex;
  }) : null;
});
export var CustomerSearchRecordCountSelector = createSelector([CustomerSearchSelector], function (customers) {
  return customers.recordCount;
});
export var CustomerSearchCurrentPageNumberSelector = createSelector([CustomerSearchSelector], function (customers) {
  return customers.pageNumber;
});
export var CustomerSearchTotalPageCountSelector = createSelector([CustomerSearchSelector], function (customers) {
  return customers.pageCount;
});
var recoverableUIStateSelector = function recoverableUIStateSelector(state) {
  return state.customercare.recoverableUiState.searchCustomers.customerSearchModel;
};
export var CustomerSearchModelSelector = createSelector([recoverableUIStateSelector], function (state) {
  return state ? state : getSearchFieldsTemplate();
});
export var CustomerSearchSuggestionsIsLoadingSelector = createSelector([CustomerSearchSelector], function (customers) {
  return customers.suggestions.isLoading;
});
export var CustomerSearchSuggestionsSelector = createSelector([CustomerSearchSelector], function (customers) {
  return customers.suggestions.data.asMutable({
    deep: true
  });
});
export var CaseSearchFieldsEnabledSelector = createSelector([BusinessUnitFetchFeatureToggleValuesSelector], function (featureToggle) {
  return featureToggle.InvCaseSearchFieldsEnabled;
});